import { PageHeader } from "../components/PageHeader";
import { openLink, haptic } from "../lib/telegram";

interface LinkItem {
  icon: string;
  color: "blue" | "purple" | "green" | "orange" | "pink" | "teal" | "indigo" | "yellow" | "red" | "mint" | "brown";
  title: string;
  subtitle: string;
  url: string;
}

const links: LinkItem[] = [
  { icon: "📷", color: "pink", title: "Instagram", subtitle: "@anton.karotki — 90 000+ подписчиков", url: "https://www.instagram.com/anton.karotki/" },
  { icon: "📨", color: "blue", title: "Telegram-канал Антона", subtitle: "Авторский канал", url: "https://t.me/antonkarotki" },
  { icon: "💸", color: "green", title: "Канал FinKeeper", subtitle: "Финансы для собственников", url: "https://t.me/finkeeper_biz" },
  { icon: "🏝", color: "teal", title: "RESIDE", subtitle: "Бюро недвижимости на Бали", url: "https://residebali.com" },
  { icon: "💰", color: "yellow", title: "FinKeeper", subtitle: "Сервис финансового учёта", url: "https://finkeeper.biz" },
  { icon: "🗝", color: "indigo", title: "RESIDE Trust", subtitle: "Управляющая компания на Бали", url: "https://trust.residebali.com" },
];

const iconBg: Record<LinkItem["color"], string> = {
  blue: "bg-[var(--icon-blue-bg)] text-[var(--icon-blue)]",
  purple: "bg-[var(--icon-purple-bg)] text-[var(--icon-purple)]",
  green: "bg-[var(--icon-green-bg)] text-[var(--icon-green)]",
  orange: "bg-[var(--icon-orange-bg)] text-[var(--icon-orange)]",
  pink: "bg-[var(--icon-pink-bg)] text-[var(--icon-pink)]",
  teal: "bg-[var(--icon-teal-bg)] text-[var(--icon-teal)]",
  indigo: "bg-[var(--icon-indigo-bg)] text-[var(--icon-indigo)]",
  yellow: "bg-[var(--icon-yellow-bg)] text-[var(--icon-yellow)]",
  red: "bg-[var(--icon-red-bg)] text-[var(--icon-red)]",
  mint: "bg-[var(--icon-mint-bg)] text-[var(--icon-mint)]",
  brown: "bg-[var(--icon-brown-bg)] text-[var(--icon-brown)]",
};

export default function Links() {
  return (
    <div className="pb-10">
      <PageHeader
        eyebrow="Соцсети и ссылки"
        title="Где меня найти"
        subtitle="Все мои каналы и проекты в одном месте."
      />
      <div className="px-5 mt-3">
        <div className="ios-group">
          {links.map((l) => (
            <button
              key={l.url}
              type="button"
              className="ios-row w-full text-left ios-card-press"
              onClick={() => { haptic("light"); openLink(l.url); }}
            >
              <div className={`icon-tile ${iconBg[l.color]}`}>{l.icon}</div>
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-ink text-[15px] leading-tight">{l.title}</div>
                <div className="text-[13px] text-muted mt-0.5 leading-snug truncate">{l.subtitle}</div>
              </div>
              <div className="text-muted text-lg leading-none">↗</div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
